export const ORACLE = {
  header: {
    root: "oracle-header",
    nav: (id) => `nav-link-${id}`,
    ctaEnquire: "header-enquire-btn",
    mobileMenuToggle: "mobile-menu-toggle",
    mobileMenu: "mobile-menu",
  },
  hero: {
    root: "hero-section",
    ctaPrimary: "hero-cta-enquire",
    ctaSecondary: "hero-cta-residences",
    tagline: "hero-tagline",
  },
  about: { root: "about-section" },
  manifesto: { root: "manifesto-section", item: (i) => `manifesto-item-${i}` },
  residences: {
    root: "residences-section",
    table: "residences-table",
    row: (i) => `residence-row-${i}`,
    enquireBtn: (i) => `residence-enquire-${i}`,
  },
  gallery: { root: "gallery-section", item: (i) => `gallery-item-${i}` },
  amenities: { root: "amenities-section", item: (i) => `amenity-${i}` },
  location: { root: "location-section" },
  enquiry: {
    root: "enquiry-section",
    form: "enquiry-form",
    fullName: "enquiry-full-name",
    mobile: "enquiry-mobile",
    email: "enquiry-email",
    propertyType: "enquiry-property-type",
    budget: "enquiry-budget",
    submit: "enquiry-submit",
    success: "enquiry-success",
  },
  footer: { root: "footer-section" },
  floating: { whatsapp: "floating-whatsapp", call: "floating-call" },
};
